export default "__VITE_ASSET__CiJSnDVC__"